import { Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useOperationsStore } from '@tom-ui/operations'
import { ConfirmationDialog } from '@tom-ui/ui'
import { OccupancyType, useYardStores, YardPositionSelector } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { AggregateIssuesViewStore } from '../Stores/AggregateIssuesViewStore'
import { OperationsIssueCard } from './OperationsIssueCard'

interface Props {
  store: AggregateIssuesViewStore
}
export const PositionMissingDialog = observer(({ store }: Props) => {
  const { t } = useTranslate()
  const [hasSelectedDestination, setHasSelectedDestination] = useState<boolean>(false)
  const { yardPositionSelectorStore } = useYardStores()
  const { appStore } = useOperationsStore()

  const issue = store.selectedMissingPositionIssue
  const journeyId = issue?.containerJourneyData?.id

  const { journeysByInboundOrderId, journeysByOutboundOrderId } =
    store.planningStores.issueViewStore.containerJourneyItemStore

  const containerJourney = issue?.orderId
    ? journeysByInboundOrderId[issue.orderId] ?? journeysByOutboundOrderId[issue.orderId]
    : undefined

  const handleConfirm = async () => {
    if (journeyId)
      await yardPositionSelectorStore.stackInJourney(
        journeyId,
        issue?.containerJourneyData?.containerNumber,
      )

    appStore.setShowAlert(
      'success',
      t('positionWasUpdatedSuccessfully', 'Position was updated successfully'),
    )
    store.toggleMissingPositionIssue()
    setHasSelectedDestination(false)
  }

  return (
    <ConfirmationDialog
      open={!!store.selectedMissingPositionIssue}
      title={t('resolveIssue', 'Resolve issue')}
      primaryActionText={t('confirm', 'Confirm')}
      primaryActionDisabled={!hasSelectedDestination}
      onConfirm={handleConfirm}
      closeLabel={t('cancel', 'Cancel')}
      maxWidth='lg'
      onClose={() => store.toggleMissingPositionIssue()}
      hasBorderTop
    >
      {store.selectedMissingPositionIssue ? (
        <Stack gap={2}>
          <OperationsIssueCard
            store={store}
            issue={store.selectedMissingPositionIssue}
            containerJourney={containerJourney}
          />

          <YardPositionSelector
            journeyId={journeyId ?? 0}
            prefillPosition={OccupancyType.Reserved}
            onChange={position => setHasSelectedDestination(!!position)}
          />
        </Stack>
      ) : (
        <Typography>{t('issueNotFound', 'Issue not found')}</Typography>
      )}
    </ConfirmationDialog>
  )
})
